import {i18n} from '@netx/core/i18n';

export const createValidationObject = () => {
	return {
		type: 'invalid',
		message: i18n.t('i18n.invalidValue'),
	};
};

export default createValidationObject;
